import { useState } from "react";

export default function Footer() {
  const handleNavigation = (
    e: React.MouseEvent<HTMLAnchorElement>,
    href: string,
  ) => {
    e.preventDefault();
    window.scrollTo({ top: 0, behavior: "instant" });
    window.REACT_APP_NAVIGATE(href);
  };

  const [isContactModalOpen, setIsContactModalOpen] = useState(false);

  const openContactModal = () => {
    setIsContactModalOpen(true);
  };

  const closeContactModal = () => {
    setIsContactModalOpen(false);
  };

  return (
    <>
      {/* Contact Modal */}
      {isContactModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg p-6 max-w-4xl w-full mx-4 max-h-[90vh] overflow-hidden">
            <div className="flex justify-between items-center mb-4">
              <h3 className="text-xl font-bold text-[#221a32]">
                Solicitar contato
              </h3>
              <button
                onClick={closeContactModal}
                className="text-[#221a32] hover:text-[#f28c1a] cursor-pointer"
              >
                <i className="ri-close-line text-2xl" />
              </button>
            </div>
            <div className="h-[600px]">
              <iframe
                width="100%"
                height="100%"
                src="https://portal.moveideias.com/workflow/public/form/9ec92cd7-ac11-4a04-8a8a-6d71c473e303"
                title="Formulário de Solicitação de contato"
                frameBorder="0"
                className="rounded-lg"
              />
            </div>
          </div>
        </div>
      )}

      <footer className="bg-[#221a32] text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
          <div className="grid grid-cols-1 md:grid-cols-5 gap-8">
            {/* Logo e Descrição */}
            <div className="col-span-1 md:col-span-2">
              <div>
                <img
                  src="/images/logo-moveideias-white.png"
                  alt="Moveideias"
                  className="h-8 w-auto mb-4"
                />
              </div>
              <p className="text-gray-300 mb-4 max-w-md">
                Integrando processos, otimizando resultados.
              </p>
              <div className="flex space-x-4">
                <a
                  href="https://linkedin.com/company/moveideias"
                  className="text-gray-300 hover:text-[#f28c1a] transition-colors cursor-pointer"
                >
                  <i className="ri-linkedin-fill text-xl" />
                </a>
                <a
                  href="https://www.facebook.com/MoveideiasMI"
                  className="text-gray-300 hover:text-[#f28c1a] transition-colors cursor-pointer"
                >
                  <i className="ri-facebook-fill text-xl" />
                </a>
                <a
                  href="https://www.instagram.com/moveideiasoficial/"
                  className="text-gray-300 hover:text-[#f28c1a] transition-colors cursor-pointer"
                >
                  <i className="ri-instagram-line text-xl" />
                </a>
                <a
                  href="https://www.youtube.com/channel/UCo5rnPCQjtzZdUJpqwF7YQg"
                  className="text-gray-300 hover:text-[#f28c1a] transition-colors cursor-pointer"
                >
                  <i className="ri-youtube-fill text-xl" />
                </a>
              </div>
            </div>

            {/* Links Rápidos */}
            <div>
              <h3 className="text-lg font-semibold mb-4">Links rápidos</h3>
              <ul className="space-y-2">
                <li>
                  <a
                    href="/"
                    onClick={(e) => handleNavigation(e, "/")}
                    className="text-gray-300 hover:text-[#f28c1a] transition-colors cursor-pointer"
                  >
                    Home
                  </a>
                </li>
                <li>
                  <a
                    href="/quem-somos"
                    onClick={(e) => handleNavigation(e, "/quem-somos")}
                    className="text-gray-300 hover:text-[#f28c1a] transition-colors cursor-pointer"
                  >
                    Quem somos
                  </a>
                </li>
                <li>
                  <a
                    href="https://youtu.be/m-BDG5js58c"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-gray-300 hover:text-[#f28c1a] transition-colors cursor-pointer"
                  >
                    Nossas soluções
                  </a>
                </li>
                <li>
                  <a
                    href="https://blog.moveideias.com/blog/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-gray-300 hover:text-[#f28c1a] transition-colors cursor-pointer"
                  >
                    Blog
                  </a>
                </li>
                <li>
                  <button
                    onClick={openContactModal}
                    className="text-gray-300 hover:text-[#f28c1a] transition-colors cursor-pointer"
                  >
                    Contato
                  </button>
                </li>
              </ul>
            </div>

            {/* Nossas Soluções */}
            <div>
              <h3 className="text-lg font-semibold mb-4">Nossas soluções</h3>
              <ul className="space-y-2">
                <li>
                  <a
                    href="/teupedido"
                    onClick={(e) => handleNavigation(e, "/teupedido")}
                    className="text-gray-300 hover:text-[#f28c1a] transition-colors cursor-pointer"
                  >
                    TeuPedido
                  </a>
                </li>
                <li>
                  <a
                    href="/movecourier"
                    onClick={(e) => handleNavigation(e, "/movecourier")}
                    className="text-gray-300 hover:text-[#f28c1a] transition-colors cursor-pointer"
                  >
                    MoveCourier
                  </a>
                </li>
                <li>
                  <a
                    href="/movepipe"
                    onClick={(e) => handleNavigation(e, "/movepipe")}
                    className="text-gray-300 hover:text-[#f28c1a] transition-colors cursor-pointer"
                  >
                    MovePipe
                  </a>
                </li>
              </ul>
            </div>

            {/* Contato */}
            <div>
              <h3 className="text-lg font-semibold mb-4">Contato</h3>
              <div className="space-y-2 text-gray-300">
                <p className="flex items-center">
                  <i className="ri-phone-line mr-2 text-[#f28c1a]" />
                  (51) 3391-0972
                </p>
                <p className="flex items-center">
                  <i className="ri-map-pin-line mr-2 text-[#f28c1a]" />
                  Porto Alegre, RS
                </p>
              </div>
            </div>
          </div>

          <div className="border-t border-gray-700 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center">
            <p className="text-gray-400 text-sm text-left">
              Copyright © 2025 – Moveideias | Todos os direitos reservados |{" "}
              <a
                href="/termos-de-uso"
                onClick={(e) => handleNavigation(e, "/termos-de-uso")}
                className="hover:text-[#f28c1a] transition-colors cursor-pointer"
              >
                Termos de Uso
              </a>
            </p>
          </div>
        </div>
      </footer>
    </>
  );
}
